











import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { Getter } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';

@Component({
	components: {
		PageHeader,
	},
})
export default class Settings extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;

	public tabs: TabItem[] = [
		{ name: 'General', route: 'general-settings' },
		{ name: 'Teammates', route: 'teammates' },
		{ name: 'Email', route: 'email' },
		{ name: 'Business Hours', route: 'business-hours' },
		{ name: 'Contact Attributes', route: 'contact-attributes' },
	];
}
